<script setup>
import About from "./components/About.vue";
import Header from "./components/Header.vue";
import { defineProps } from "vue";
import Services from "./components/Services/Services.vue";
import Portfolio from "./components/Portfolio/Portfolio.vue";
import Contact from "./components/Contact/Contact.vue";
import Footer from "./components/Footer.vue";

const navItems = [
  { name: "Home", sectionId: "home" },
  { name: "About", sectionId: "about" },
  { name: "Services", sectionId: "services" },
  { name: "Portfolio", sectionId: "portfolio" },
  { name: "Contact", sectionId: "contact" },
];

defineProps({
  navItems: {
    type: Array,
  },
});
</script>

<template>
  <div class="bg-black h-auto cursor-pointer">
    <div id="home">
      <Header :navItems="navItems" />
    </div>
    <div id="about">
      <transition name="slide-in">
        <About />
      </transition>
    </div>
    <div id="services"><Services /></div>
    <div id="portfolio"><Portfolio /></div>
    <div id="contact"><Contact /></div>
    <div><Footer :navItems="navItems" /></div>
  </div>
</template>

<style>
.slide-in-enter-active,
.slide-in-leave-active {
  transition: all 2s ease;
}

.slide-in-enter,
.slide-in-leave-to {
  transform: translateX(-100%);
}

/* This will make sure the component fills its container */
.slide-in-leave-active,
.slide-in-enter {
  position: absolute;
  width: 100%;
  height: 100%;
}

.header-ctn {
  background-image: url("./assets/images/hero-bg.jpeg");
  background-repeat: repeat;
  background-position: center;
}

.scrollable {
  overflow: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
}

/* Hide the scroll bar for WebKit browsers (Chrome, Safari) */
.scrollable::-webkit-scrollbar {
  width: 0;
  background-color: transparent;
}

body {
  font-family: "Source Sans Pro", sans-serif;
}

.nav-links::after {
  content: '';
  width: 0%;
  height: 2px;
  background: rgb(139, 106, 15);
  display: block;
  margin: auto;
  transition: 0.5s;
}

.nav-links:hover::after {
  width: 100%;
}
</style>
